export const SMOKE_TYPE_ID = Object.freeze({
  SMOKING: 1,
  NO_SMOKING: 2,
  CAN_STOP_SMOKING_ON_DATE: 3,
  ELECTRONIC_CIGARETTE: 4,
});

export type SmokeTypeId = (typeof SMOKE_TYPE_ID)[keyof typeof SMOKE_TYPE_ID];
export type SmokingSearchValue = SmokeTypeId | null;

const SMOKE_UNSELECTED_VALUE = "";
type SmokeTypeOptionValue = SmokeTypeId | typeof SMOKE_UNSELECTED_VALUE;

export const SMOKE_TYPE_LIST = {
  [SMOKE_UNSELECTED_VALUE]: "未選択",
  [SMOKE_TYPE_ID.NO_SMOKING]: "吸わない",
  [SMOKE_TYPE_ID.SMOKING]: "吸う",
  [SMOKE_TYPE_ID.ELECTRONIC_CIGARETTE]: "吸う（電子タバコ）",
  [SMOKE_TYPE_ID.CAN_STOP_SMOKING_ON_DATE]: "吸うがデート中は我慢できる",
} satisfies Record<SmokeTypeOptionValue, string>;

const SMOKE_ROW_VALUES: SmokeTypeOptionValue[] = [
  SMOKE_UNSELECTED_VALUE,
  SMOKE_TYPE_ID.SMOKING,
  SMOKE_TYPE_ID.ELECTRONIC_CIGARETTE,
  SMOKE_TYPE_ID.NO_SMOKING,
  SMOKE_TYPE_ID.CAN_STOP_SMOKING_ON_DATE,
];

export const SMOKE_ROW = SMOKE_ROW_VALUES.map(
  (smokeType) => SMOKE_TYPE_LIST[smokeType],
);

const DISABLED_SMOKE_TYPE_IDS: SmokeTypeId[] = [
  SMOKE_TYPE_ID.SMOKING,
  SMOKE_TYPE_ID.ELECTRONIC_CIGARETTE,
  SMOKE_TYPE_ID.CAN_STOP_SMOKING_ON_DATE,
];
const disabledSmokeTypeIdSet = new Set<SmokeTypeOptionValue>(
  DISABLED_SMOKE_TYPE_IDS,
);

export const DISABLE_SMOKE_TYPE_IDX_SET = new Set<number>();

for (const [index, smokeType] of SMOKE_ROW_VALUES.entries()) {
  if (disabledSmokeTypeIdSet.has(smokeType)) {
    DISABLE_SMOKE_TYPE_IDX_SET.add(index);
  }
}

export const DISABLE_SMOKE_TYPE_KEY_SET = new Set<SmokeTypeId>(
  DISABLED_SMOKE_TYPE_IDS,
);
